// Section 24.12 and 2 (hard rule): a run is replayable from (seed, decisionLog) to an identical
// state, using the config snapshot it was played with. Continuing in sandbox after a win is not a
// decision (ADR-0015), so a log that goes on past a win re-applies it (Section 20).
import { continueInSandbox, newGame, step, type Config, type GameState } from '../sim/api';
import { completeConfig } from './config';
import type { SaveEnvelope } from './envelope';

export interface ReplayOptions {
  checkInvariants?: boolean;
  /** Replay on this config instead of the snapshot (fork onto the current balance). */
  cfg?: Config;
}

export function replay(
  envelope: Pick<SaveEnvelope, 'seed' | 'options' | 'decisionLog' | 'configSnapshot'>,
  opts: ReplayOptions = {},
): GameState {
  const cfg: Config = opts.cfg ?? completeConfig(envelope.configSnapshot);
  const common = {
    cfg,
    ...(opts.checkInvariants === undefined ? {} : { checkInvariants: opts.checkInvariants }),
  };
  let state = newGame(envelope.options, envelope.seed, common);
  for (const decision of envelope.decisionLog) {
    if (state.outcome?.kind === 'won' && !state.sandbox) state = continueInSandbox(state);
    state = step(state, decision, common).state;
  }
  return state;
}
